export const getUsers = (state) => state.users
export const getUser = (state) => state.user
export const getCurrentUser = (state) => state.current

export const getSessionAccount = (state) => state.session_account
export const getSessionTeam = (state) => state.session_team

export const getAccounts = (state) => state.accounts
export const getAccount = (state) => state.account
export const getAccountCountries = (state) => state.accountcountries

export const getProjects = (state) => state.projects
export const getProject = (state) => state.project

export const getTeams = (state) => state.teams
export const getTeam = (state) => state.team

export const getCampaigns = (state) => state.campaigns
export const getCampaign = (state) => state.campaign

export const getSocialReasons = (state) => state.socialreasons

export const getSuppliers = (state) => state.suppliers
export const getSupplier = (state) => state.supplier

export const getClients = (state) => state.clients
export const getClient = (state) => state.client

export const getBudgets = (state) => state.budgets
export const getBudget = (state) => state.budget
export const getBudgetStates = (state) => state.budgetstates

export const getBudgetElements = (state) => state.budgetelements
export const getBudgetElement = (state) => state.budgetelement

export const getTasks = (state) => state.tasks
export const getTask = (state) => state.task
export const getTaskStates = (state) => state.taskstates
export const getTaskVersions = (state) => state.taskversions
export const getTaskVersion = (state) => state.taskversion

export const getEmails = (state) => state.emails
export const getEmail = (state) => state.email
export const getEmailStates = (state) => state.emailstates
export const getEmailVersions = (state) => state.emailversions
export const getEmailVersion = (state) => state.emailversion
export const getEmailChecks = (state) => state.emailchecks
export const getEmailCheck = (state) => state.emailcheck
export const getEmailClassifications = (state) => state.emailclassifications
export const getEmailClassification = (state) => state.emailclassification

export const getProfiles = (state) => state.profiles
export const getProfile = (state) => state.profile

export const getHours = (state) => state.hours
export const getHour = (state) => state.hour

export const getCalendars = (state) => state.calendars
export const getCalendar = (state) => state.calendar

export const getNotifications = (state) => state.notifications
export const getNotification = (state) => state.notification

export const getLibrary = (state) => state.library
export const getLibraries = (state) => state.libraries

export const getActivity = (state) => state.activity
export const getActivities = (state) => state.activities

export const getIsLoading = (state) => state.isLoading



// WEBPACK FOOTER //
// ./src/vuex/entity/getters.js